import RolesUtil from 'permissions/utils/roles';
const OmniaPermissions = {
  canEditOmniaEngagements: (stateData, projectID) =>
    RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
    RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData, projectID),
  canShareFile: (stateData) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData) ||
      RolesUtil.doesUserHavePreparerReviewerRoleForProject(stateData)
    );
  },
};

export default OmniaPermissions;
